import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-widget-population',
    templateUrl: './population.component.html',
    styleUrls: ['./population.component.scss']
})

export class PopulationComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    echartsIntance = null;

    /**
     * Chart demographie
     */

    options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: '{a} <br/>{b} : {c}'
        },
        grid: [{
            left: '20px',
            right: '10px',
            top: '10px',
            bottom: '20px',
            containLabel: true
        }],
        xAxis: {
            type: 'category',
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
            axisLabel: { interval: 0, rotate: 45 },
        },

        yAxis: {
            type: 'value',
            min: 1000000,
        },
        color: ['#5FB761'],

        series: []

    };

    data = {};

    constructor() {
    }

    ngOnInit() {
        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        // setTimeout(function() {
        //     window.open(this.echartsIntance.getDataURL({
        //         pixelRatio: 10,
        //         backgroundColor: 'transparent'
        //     }), '_blank');
        // }.bind(this), 3000);
    }

    setData() {
        this.options.yAxis.min = 1000000;
        this.options.xAxis.data = [];

        const dataPop = [];
        Object.keys(this.favorite.ad_city.demographie_annuelle).forEach(keys => {
            if (keys !== 'Cr') {
                dataPop.push(this.favorite.ad_city.demographie_annuelle[keys]);
                this.options.xAxis.data.push(keys);
                if (this.options.yAxis.min > (this.favorite.ad_city.demographie_annuelle[keys] * 0.9)) {
                    this.options.yAxis.min = Math.round(this.favorite.ad_city.demographie_annuelle[keys] * 0.9 / 1000 - 1) * 1000;
                }
            }
        });

        if (this.options.yAxis.min < 0) {
            this.options.yAxis.min = 0;
        }

        this.data = {
            series: [
                {
                    // animation: false,
                    name: this.favorite.ad_city.name,
                    type: 'bar',
                    data: dataPop,
                },
            ]
        };
        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.options);
        }
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }
}
